import { render, staticRenderFns } from "./OtherDistributions.vue?vue&type=template&id=34f920b2&scoped=true"
import script from "./OtherDistributions.vue?vue&type=script&lang=js"
export * from "./OtherDistributions.vue?vue&type=script&lang=js"
import style0 from "./OtherDistributions.vue?vue&type=style&index=0&id=34f920b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f920b2",
  null
  
)

export default component.exports